import WithRender from "../../templates/imageEditor/formatEditor.html";
import { mapGetters } from "vuex";
import { Drop } from "vue-drag-drop";

import WallpaperLines from "../imageEditor/WallpaperLines";
import CornersFormat from "../imageEditor/CornersFormat";
import LayerEditor from "../imageEditor/LayerEditor";

export default WithRender({
  props: ["dosen"],
  components: {
    drop: Drop,
    appWallpaperLines: WallpaperLines,
    appCornersFormat: CornersFormat,
    appLayerEditor: LayerEditor
  },
  computed: {
    ...mapGetters([
      "getFormat",
      "getEditor",
      "getImage",
      "getFullFormatDim",
      "getMargin",
      "canvasFormatDimByFormat",
      "getReady",
      "getFullMargins",
      "pdfUnit",
      "canvasFormatDimByFormat",
      "getBckMode"
    ]),
    focalPoint: function () {
      return this.getEditor.focalPoint;
    },
    zoom: function () {
      return this.getEditor.zoom;
    },
    originalImage: function () {
      return this.getImage.original;
    },
    fullFormat: function () {
      return this.getFullFormatDim;
    },
    fullMargins: function () {
      return this.getFullMargins;
    },
    format: function () {
      return this.getFormat;
    },
    margins: function () {
      return this.getMargin;
    },
    thickness: function () {
      return this.getThickness.thickness;
    },
    isHor: function () {
      return this.format.type == 1;
    },
    isVer: function () {
      return this.format.type == 2;
    },
    isRou: function () {
      return this.format.rounded == 1;
    },
    image: function () {
      return this.getImage;
    },
    format: function () {
      return this.getFormat;
    },
    getMarginViewStyle: function () {
      if (this.getReady) {
        var size = this.canvasFormatDimByFormat;
        var result = {
          width: Math.round(size.width) + "px",
          height: Math.round(size.height) + "px",
          top: Math.round(size.top) + "px",
          left: Math.round(size.left) + "px"
        };
        return result;
      }
      return {};
    },
    getMarginViewBg: function () {
      if (this.margins.type < 0) {
        return {
          "background-color": "rgba(0,0,0,0)"
        };
      }
      return {
        "background-color": "#fff"
      };
    },
    getStyle: function () {
      if (this.getReady) {
        var size = this.canvasFormatDimByFormat;
        var result = {
          width: Math.round(size.width) + "px",
          height: Math.round(size.height) + "px",
          top: Math.round(size.top) + "px",
          left: Math.round(size.left) + "px"
        };
        return result;
      }
      return {};
    },
    getBackgroundStyle: function () {
      if (this.getReady) {
        var result = {};
        if (this.margins.type < 0) {
          //enlarged
          result["background"] = "none";
        } else {
          if (this.margins.subtype == 1) {
            // mirrored
            result["background"] = "none";
          }
          if (this.getEditor.marginView) {
            if (this.margins.subtype == 2) {
              // white
              result["background"] = this.margins.color;
            }
            if (this.margins.subtype == 3) {
              // monochrome
              result["background"] = this.margins.color;
            }
          }
        }
        return result;
      }
      return {};
    },
    getCropStyle: function () {
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;

        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (size.left + size1.left)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (size.top + size1.top)) *
          -1;

        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);

        var result = {
          width: width + "px",
          height: height + "px",
          top: size.top - 1 + "px",
          left: size.left - 1 + "px",
          "background-image": "url('" + this.image.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
        return result;
      }
      return {};
    },
    getMirrored: function () {
      return this.margins.type == 1 && this.margins.subtype == 1;
    },
    getRandOption: function () {
      return this.margins.rand_option == 1 && this.margins.rand_option == 1;
    },
    getMirroredTopStyle: function () {
      var result = [];
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);

        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (size1.left + size.left)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (size1.top + size.top)) *
          -1;

        result = {
          width: width + "px",
          height: size.top + "px",
          left: size.left + "px",
          top: "0px",
          "background-image":
            "url('" + this.$store.state.imageEditor.image.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
      }
      return result;
    },
    getMarginTopStyle: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var font = 16;
        if (size.top < 12) {
          font = size.top;
        }
        result = {
          height: size.top + "px",
          "line-height": size.top + "px",
          left: "0px",
          top: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    getMirroredBottomStyle: function () {
      var result = [];
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);
        var bottom = size1.height - height - size.top;
        var bg_left = -1 * size1.left;
        var bg_top = -1 * (height + size1.top - bottom);
        bg_top = Math.round(bg_top - (zoomH - size.height) / 2);
        bg_left = Math.round(bg_left - (zoomW - size.width) / 2);
        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (size1.left + size.left)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (height + size1.top + size.top - bottom)) *
          -1;
        result = {
          width: width + "px",
          height: bottom + "px",
          left: size.left + "px",
          bottom: "0px",
          "background-image":
            "url('" + this.$store.state.imageEditor.image.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
      }
      return result;
    },
    getMarginBottomStyle: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;

        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var bottom = size1.height - height - size.top;
        var font = 16;
        if (size.top < 12) {
          font = size.bottom;
        }
        result = {
          height: bottom + "px",
          "line-height": bottom + "px",
          left: "0px",
          bottom: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    getMirroredLeftStyle: function () {
      var result = [];
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);

        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (size1.left + size.left)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (size1.top + size.top)) *
          -1;

        result = {
          width: size.left + "px",
          height: height + "px",
          left: "0px",
          top: size.top + "px",
          "background-image":
            "url('" + this.$store.state.imageEditor.image.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
      }
      return result;
    },
    getMarginLeftStyle: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        //var size1     = this.calculateFormatDim ();
        var size1 = this.canvasFormatDimByFormat;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var font = 16;

        if (size.left < 12) {
          font = size.left;
        }
        result = {
          width: size.left + "px",
          left: "0px",
          top: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    getMirroredRightStyle: function () {
      var result = [];
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);
        var right = size1.width - width - size.left;

        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (width + size1.left + size.left - right)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (size1.top + size.top)) *
          -1;

        result = {
          width: right + "px",
          height: height + "px",
          right: "0px",
          top: size.top + "px",
          "background-image":
            "url('" + this.$store.state.imageEditor.image.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
      }
      return result;
    },
    getMarginRightStyle: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;

        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var right = size1.width - width - size.left;
        var font = 16;
        if (right < 12) {
          font = right;
        }

        result = {
          width: right + "px",
          right: "0px",
          top: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    unit: function () {
      return (
        this.getEditor.dim.imageDimByFormat.unit /
        this.getEditor.dim.canvasDimByFormat.unit
      );
    },
    formatChanges: function () {
      return this.fullFormat;
    }
  },
  methods: {
    handleDrop(data, event) {
      if (data) {
        const { type, id } = data;
        const { pageX, pageY } = event;
        const el = this.$refs.formatLayer;
        const $el = $(this.$refs.formatLayer);
        const offset = $el.offset();
        const unit = this.unit;
        let top = pageY - offset.top;
        let left = pageX - offset.left;

        switch (type) {
          case "local_image":
            if ($el.width() < left + 100) left = $el.width() - 100;
            if ($el.height() < top + 100) top = $el.height() - 100;

            if (top < 0) top = 0;
            if (left < 0) left = 0;

            const background = this.getBckMode | 0;

            const dataToSend = {
              uuid: id,
              left: left / unit,
              top: ($el.height() - top) / unit,
              background: background
            };

            this.$store.dispatch("getResizedImage", dataToSend);

            break;
        }
      }
    }
  },
  watch: {
    formatChanges: {
      handler: function () {
        this.$nextTick(() => {
          this.$store.dispatch("checkItemPosition", {});
        });
      },
      deep: false
    }
  }
});
